import { Button, SceneWrapper, TextInput, Typography } from '~/components';
import { getTheme, pxToRem, styled } from '~/modules';

const spacingMd = getTheme('spacing.md');
const spacingXxl = getTheme('spacing.xxl');

const borderRadiusMax = getTheme('borderRadius.max');

export const Wrapper = styled(SceneWrapper)`
  flex: 1;
`;

export const ContentBox = styled.div`
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Title = styled(Typography).attrs({ variant: 'xl' })`
  font-weight: bold;
  text-align: center;
  margin-bottom: ${spacingMd}px;
`;

export const Input = styled(TextInput)`
  max-width: ${pxToRem(635)};
  margin-right: ${spacingMd}px;
  margin-bottom: ${spacingXxl}px;
`;

export const ButtonSearch = styled(Button)`
  width: ${pxToRem(280)};
  height: ${pxToRem(60)};
  border-radius: ${borderRadiusMax}px;
`;
